"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var service_service_1 = require("../../Services/service.service");
var WickedApiClient_1 = require("src/app/api/WickedApiClient");
var operators_1 = require("rxjs/operators");
var geolocation_service_1 = require("../../Services/geolocation.service");
var rxjs_1 = require("rxjs");
var ngx_cookie_service_1 = require("ngx-cookie-service");
var seo_service_1 = require("../../Services/seo.service");
var searchroute_service_1 = require("../../Services/searchroute.service");
var ngx_mat_select_search_1 = require("ngx-mat-select-search");
var searchroute_service_2 = require("./../../Services/searchroute.service");
var SearchType;
(function (SearchType) {
    SearchType[SearchType["City"] = 0] = "City";
    SearchType[SearchType["Zip"] = 1] = "Zip";
})(SearchType || (SearchType = {}));
var SearchSmallComponent = /** @class */ (function () {
    function SearchSmallComponent(router, fb, service, geolocationService, cookieService, seo, searchRouteService) {
        this.router = router;
        this.fb = fb;
        this.service = service;
        this.geolocationService = geolocationService;
        this.cookieService = cookieService;
        this.seo = seo;
        this.searchRouteService = searchRouteService;
        this._searchType = SearchType.City;
        this.miles = [
            { value: 0, viewValue: 'none' },
            { value: 10, viewValue: '10' },
            { value: 25, viewValue: '25' },
            { value: 50, viewValue: '50' },
            { value: 75, viewValue: '75' },
        ];
        this.autoLocation = false;
        this._type = "home";
        this.regionFilter = new forms_1.FormControl();
        this.subregionFilter = new forms_1.FormControl();
        this.regions = [];
        this.subRegions = [];
        this.tmpSearchedSubRegions = [];
        this.limit = 10;
        this.offset = 0;
        this.subRegionsOptions = new rxjs_1.BehaviorSubject([]);
        this.loading = false;
        this._withPicturesOnly = false;
        this.advSearchForm = this.fb.group({
            region: [null],
            subregion: [null],
            zipCode: [null, forms_1.Validators.compose([forms_1.Validators.minLength(5), forms_1.Validators.maxLength(5)])],
            casualDating: [false],
            relationShips: [null],
            miles: [null],
            keywords: [null],
            withPicturesOnly: [null]
        }, {
            validators: exports.validateSubRegionAndZip
        });
        this.subRegionsOptions$ = this.subRegionsOptions.asObservable().pipe(operators_1.scan(function (acc, curr) {
            if (curr.length === 0)
                return [];
            else
                return acc.concat(curr);
        }, []));
    }
    Object.defineProperty(SearchSmallComponent.prototype, "SearchType", {
        get: function () {
            return this._searchType;
        },
        set: function (value) {
            this._searchType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchSmallComponent.prototype, "SearchTypes", {
        get: function () { return SearchType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchSmallComponent.prototype, "withPicturesOnly", {
        get: function () {
            return this._withPicturesOnly;
        },
        set: function (value) {
            this._withPicturesOnly = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchSmallComponent.prototype, "strBlogUrl", {
        get: function () {
            return this.service.advService.blogURL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SearchSmallComponent.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            this._type = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    SearchSmallComponent.prototype.getRouter = function () { return this.router; };
    ;
    SearchSmallComponent.prototype.openedChange = function (opened) {
        if (opened && !this.subregionFilter.value && this.subRegions.length > 0) {
            this.getNextBatch(this.subRegions);
        }
    };
    SearchSmallComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.service.selectedSearchParams = this.advSearchForm;
        this.subregionFilter.valueChanges.subscribe(function (val) { _this.onSearchChange(val); });
        this.categories = this.service.advService.getCategoriesObservable();
        this.service.advService.getRegionsOnlyPromise().then(function (r) {
            _this.regions = r;
        });
        this.service.advService.searchInActionChanged.subscribe(function (s) {
            _this.loading = s;
        });
        this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(function (data) {
            if (data.regionId) {
                _this.subRegions = _this.service.advService.getSubRegionsByRegionId(data.regionId);
            }
        });
        this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(function (data) {
            if (_this.isSearchRoute()) {
                if (!data._type) {
                    _this.advSearchForm.setValue({
                        region: data.regionId || 0,
                        subregion: data.subRegionId || 0,
                        casualDating: data.casualDating || false,
                        relationShips: data.advertisementCategoryId || 0,
                        miles: data.miles || 50,
                        zipCode: data.zipCode || "",
                        keywords: data.keywords || "",
                        withPicturesOnly: data.withPicturesOnly || false,
                    });
                }
            }
            else {
                _this.advSearchForm.setValue({
                    region: data.regionId || 0,
                    subregion: data.subRegionId || 0,
                    casualDating: data.casualDating || false,
                    relationShips: data.advertisementCategoryId || 0,
                    miles: data.miles || 50,
                    zipCode: data.zipCode || "",
                    keywords: data.keywords || "",
                    withPicturesOnly: data.withPicturesOnly || false,
                });
            }
        });
    };
    SearchSmallComponent.prototype.changeSearchType = function (event) {
        event.preventDefault();
        if (this.SearchType == SearchType.City) {
            this.SearchType = SearchType.Zip;
        }
        else {
            this.SearchType = SearchType.City;
        }
    };
    SearchSmallComponent.prototype.clearSearch = function () {
        this.advSearchForm.controls["casualDating"].setValue(false);
        this.advSearchForm.controls["relationShips"].setValue(null);
        this.advSearchForm.controls['keywords'].setValue("");
        this.advSearchForm.controls["withPicturesOnly"].setValue(false);
        this.advSearchForm.controls["miles"].setValue("");
        this.advSearchForm.controls["zipCode"].setValue("");
        this.advSearchForm.controls["region"].setValue(null);
        this.advSearchForm.controls["subregion"].setValue(null);
    };
    SearchSmallComponent.prototype.isSearchRoute = function () {
        var regex = new RegExp(searchroute_service_2.RegexSearchList, "gi");
        var regexMatch = regex.exec(this.router.url.replace("/", ""));
        if (regexMatch != null && regexMatch.groups != null) {
            return true;
        }
        else {
            return false;
        }
    };
    SearchSmallComponent.prototype.ngOnDestroy = function () {
        if (this.changeSearchDataSubscription) {
            this.changeSearchDataSubscription.unsubscribe();
        }
    };
    Object.defineProperty(SearchSmallComponent.prototype, "filteredSubregion", {
        get: function () {
            var _this = this;
            if (!this.subRegions) {
                return [];
            }
            var search = this.subregionFilter.value;
            if (!search) {
                return this.subRegions;
            }
            else {
                return this.subRegions.filter(function (r) { return r.name.toLowerCase().startsWith(search.toLowerCase()) || r.subRegionId == _this.advSearchForm.controls["subregion"].value; });
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchSmallComponent.prototype.getNextBatch = function (data) {
        var _this = this;
        var result = data.slice(this.offset, this.offset + this.limit);
        this.subRegionsOptions.subscribe(function (r) {
            var setFirstItemActivebk = _this.citySearchSelect.matSelect._keyManager.setFirstItemActive;
            _this.citySearchSelect.matSelect._keyManager.setFirstItemActive = function () { };
            // restoring setFirstItemActive fn
            setTimeout(function () {
                _this.citySearchSelect.matSelect._keyManager.setFirstItemActive = setFirstItemActivebk;
            }, 1000);
        });
        if (result.length > 0) {
            this.subRegionsOptions.next(result);
            this.offset += this.limit;
        }
    };
    SearchSmallComponent.prototype.callGetNextBatch = function () {
        if (this.subregionFilter.value) {
            this.getNextBatch(this.tmpSearchedSubRegions);
        }
        else {
            this.getNextBatch(this.subRegions);
        }
    };
    SearchSmallComponent.prototype.onSearchChange = function (e) {
        this.subRegionsOptions.next([]);
        var val = e ? e.trim() : null;
        if (!val) {
            this.offset = 0;
            this.tmpSearchedSubRegions = [];
            this.getNextBatch(this.subRegions);
            return;
        }
        else {
            val = val.toLowerCase();
            this.tmpSearchedSubRegions = this.filteredSubregion;
            this.subRegionsOptions.next(this.tmpSearchedSubRegions);
        }
    };
    SearchSmallComponent.prototype.getRegionData = function (regionId) {
        return this.regions.find(function (r) { return r.regionId == regionId; });
    };
    Object.defineProperty(SearchSmallComponent.prototype, "filteredRegions", {
        get: function () {
            var _this = this;
            if (!this.regions || this.regions.length == 0) {
                return [];
            }
            var search = this.regionFilter.value;
            if (!search) {
                return this.regions;
            }
            else {
                return this.regions.filter(function (r) { return r.name.toLowerCase().startsWith(search.toLowerCase()) || r.regionId == _this.advSearchForm.controls["region"].value; });
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchSmallComponent.prototype.setSelectedRegion = function (regionId) {
        var _this = this;
        if (regionId) {
            this.service.advService.getSubRegionsForRegionPromise(regionId).then(function (r) {
                _this.subRegions = r;
                _this.advSearchForm.controls["subregion"].setValue(r[0].subRegionId);
                _this.offset = 0;
                _this.subRegionsOptions.next([]);
                _this.getNextBatch(_this.subRegions);
            });
        }
    };
    SearchSmallComponent.prototype.onSubmit = function (navigateToSearchResult, navigateURL) {
        var _this = this;
        if (navigateToSearchResult === void 0) { navigateToSearchResult = true; }
        if (navigateURL === void 0) { navigateURL = "search-results"; }
        this.seo.updateMetaTagsBySearch(parseInt(this.advSearchForm.controls["relationShips"].value));
        if (this.advSearchForm.valid) {
            this.service.advService.searchDataStandard.currentSearchRule.pageNumber = 0;
            this.service.advService.searchDataStandard.currentSearchRule.regionId = this.SearchType == SearchType.City ? parseInt(this.advSearchForm.controls["region"].value) : null;
            if (isNaN(this.service.advService.searchDataStandard.currentSearchRule.regionId)) {
                this.service.advService.searchDataStandard.currentSearchRule.regionId = null;
            }
            this.service.advService.searchDataStandard.currentSearchRule.casualDating = this.advSearchForm.controls["casualDating"].value;
            this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = this.advSearchForm.controls["relationShips"].value;
            this.service.advService.searchDataStandard.currentSearchRule.subRegionId = this.SearchType == SearchType.City ? parseInt(this.advSearchForm.controls["subregion"].value) : null;
            if (isNaN(this.service.advService.searchDataStandard.currentSearchRule.subRegionId)) {
                this.service.advService.searchDataStandard.currentSearchRule.subRegionId = null;
            }
            this.service.advService.searchDataStandard.currentSearchRule.miles = this.SearchType == SearchType.City ? null : (this.advSearchForm.controls["miles"].value ? Number(this.advSearchForm.controls["miles"].value.value) : null);
            this.service.advService.searchDataStandard.currentSearchRule.zipCode = this.SearchType == SearchType.City ? null : this.advSearchForm.controls["zipCode"].value;
            this.service.advService.searchDataStandard.currentSearchRule.keywords = this.advSearchForm.controls["keywords"].value;
            this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly = this.advSearchForm.controls["withPicturesOnly"].value;
            if (navigateToSearchResult && navigateURL == "urlsearch" && this.service.advService.searchDataStandard.currentSearchRule.regionId != null && this.service.advService.searchDataStandard.currentSearchRule.subRegionId != null) {
                if (this.SearchType == SearchType.Zip) {
                    this.service.advService.searchAction(true, "search-results");
                }
                else {
                    var state = this.regions.find(function (r) { return r.regionId == _this.service.advService.searchDataStandard.currentSearchRule.regionId; });
                    var city = this.subRegions.find(function (r) { return r.subRegionId == _this.service.advService.searchDataStandard.currentSearchRule.subRegionId; });
                    var category = Object.keys(searchroute_service_1.Categories)[Object.values(searchroute_service_1.Categories).findIndex(function (x) { return x == _this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId; })];
                    var withPicture = this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly ? "-with-picture" : "";
                    var casualDating = this.service.advService.searchDataStandard.currentSearchRule.casualDating ? "casual-dating" : "long-term";
                    var url = state.shortName.toLowerCase() + "-" + city.name.replace(" ", "-").toLowerCase() + "-" + casualDating + withPicture;
                    if (category) {
                        url = state.shortName.toLowerCase() + "-" + city.name.replace(" ", "-").toLowerCase() + "-" + casualDating + "-" + category.replace(" ", "-").toLowerCase() + withPicture;
                    }
                    this.router.navigateByUrl('/', { skipLocationChange: true }).then(function () {
                        return _this.router.navigate([url]);
                    });
                }
            }
            else {
                if (this.SearchType == SearchType.Zip) {
                    this.service.advService.searchAction(true, "search-results");
                }
                else {
                    this.service.advService.searchAction(navigateToSearchResult, navigateURL);
                }
            }
        }
        else if (this.advSearchForm.errors && this.advSearchForm.errors.zipOrSubRegionReqired) {
            this.service.showWarning("Please enter City or Zip");
        }
        ;
    };
    return SearchSmallComponent;
}());
exports.SearchSmallComponent = SearchSmallComponent;
exports.validateSubRegionAndZip = function (control) {
    var zipCode = control.get("zipCode").value;
    var subregion = control.get("subregion").value;
    return (!zipCode || (zipCode || "") == "") && (!subregion && (isNaN(Number(subregion)) || Number(subregion) <= 0)) ? { zipOrSubRegionReqired: true } : null;
};
